<div class="rewards-tab rewards-tab-v2">
  <app-reward-earning-criteria
    [activeRules]="activeRewardRules"
    [isLoading]="isLoadingRules"
    (rewardSettingsClick)="openRewardRuleModal()">
  </app-reward-earning-criteria>

  <div class="rewards-sub-tabs-stack">
    <div
      class="rewards-summary-filters search-filter-section"
      [class.filters-disabled]="summaryFiltersDisabled">
      <app-searchbar
        placeholder="Search employees by name or employee ID"
        [(searchTerm)]="summarySearchTerm"
        (searchChange)="onSummarySearchChange($event)"
        iconSize="small">
      </app-searchbar>
      <div class="filter-container">
        <div class="period-section">
          <span class="period-label">Period</span>
          <div class="period-dropdown-wrapper">
            <button
              type="button"
              class="dropdown-button"
              [disabled]="summaryFiltersDisabled"
              (click)="toggleSummaryDateRangePicker(); $event.stopPropagation()">
              <span>{{ selectedSummaryPeriod }}</span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [class.rotated]="isSummaryDateRangePickerOpen">
                <path
                  d="M5.28 7.38L10 12.1L14.72 7.38"
                  stroke="#15172E"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
            <app-date-range-picker
              [isOpen]="isSummaryDateRangePickerOpen"
              [selectedPeriod]="selectedSummaryPeriod"
              [customDateRange]="summaryCustomDateRange"
              [periodOptions]="summaryPeriodOptions"
              (periodChange)="onSummaryDateRangePeriodChange($event)"
              (customDateRangeChange)="onSummaryCustomDateRangeChange($event)"
              (close)="closeSummaryDateRangePicker()"
              (apply)="onSummaryDateRangeApply($event)">
            </app-date-range-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="rewards-section-card rewards-sub-tabs-header">
      <app-tab-header
        [tabs]="subTabs"
        [activeTabId]="activeSubTab"
        customClass="rewards-v2-sub-tabs"
        (tabChange)="onSubTabChange($event)">
      </app-tab-header>
    </div>

    <div class="rewards-sub-tab-content" *ngIf="activeSubTab === 'summary'">
      <app-rewards-summary-tab
        [columns]="summaryColumns"
        [items]="summaryItems"
        [loading]="isLoadingSummary">
      </app-rewards-summary-tab>
    </div>

    <app-pagination-bar
      *ngIf="activeSubTab === 'summary' && showSummaryPagination"
      [paginationData]="summaryPaginationData"
      [itemsPerPageOptions]="summaryItemsPerPageOptions"
      (pageChange)="onSummaryPageChange($event)"
      (itemsPerPageChange)="onSummaryItemsPerPageChange($event)">
    </app-pagination-bar>

    <div class="rewards-sub-tab-content" *ngIf="activeSubTab === 'rewards-list'">
      <app-rewards-list-tab
        [rewardRules]="rewardRules"
        [isLoadingRules]="isLoadingRules"
        (ruleDisabled)="onRuleDisabled()"
        (editRule)="openRewardRuleModalForEdit($event)">
      </app-rewards-list-tab>
    </div>
  </div>
</div>

<app-reward-rule-modal
  [isOpen]="showRewardRuleModal"
  [editingRule]="editingRule"
  (closeModal)="closeRewardRuleModal()"
  (ruleCreated)="onRuleCreated()"
  (ruleUpdated)="onRuleUpdated()">
</app-reward-rule-modal>
